// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__37gON","expandIcon":"AccordionButton_expandIcon__2mi-H","expanded":"AccordionButton_expanded__3jMh8"};